if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.mediaItems = null;
        this.activeIndex = 0;
      }

      hide() {
        super.hide();
      }

      show(opener) {
        super.show(opener);
        this.showActiveMedia();
        this.bindNav();
      }

      showActiveMedia() {
        this.mediaItems = Array.from(this.querySelectorAll('[data-media-id]'));

        this.mediaItems.forEach((element, index) => {
          const isActive = element.getAttribute('data-media-id') === this.openedBy.getAttribute('data-media-id');
          element.classList.toggle('active', isActive);
          if (isActive) this.activeIndex = index;
        });

        const activeMedia = this.mediaItems[this.activeIndex];
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateDots();
      }

      setActiveByIndex(index) {
        if (!this.mediaItems || this.mediaItems.length === 0) return;
        this.activeIndex = (index + this.mediaItems.length) % this.mediaItems.length;

        this.mediaItems.forEach((element, i) => {
          element.classList.toggle('active', i === this.activeIndex);
        });

        const activeMedia = this.mediaItems[this.activeIndex];
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;

        if (
          activeMedia.nodeName == 'DEFERRED-MEDIA' &&
          activeMediaContent &&
          activeMediaContent.querySelector('.js-youtube')
        )
          activeMedia.loadContent();

        this.updateDots();
      }

      updateDots() {
        const dots = this.querySelectorAll('.product-media-modal__dot');
        dots.forEach((dot, i) => {
          dot.classList.toggle('is-active', i === this.activeIndex);
        });
      }

      bindNav() {
        if (this.navBound) return;
        this.navBound = true;

        const prevButton = this.querySelector('.product-media-modal__nav--prev');
        const nextButton = this.querySelector('.product-media-modal__nav--next');
        const dots = this.querySelectorAll('.product-media-modal__dot');

        if (prevButton) prevButton.addEventListener('click', () => this.setActiveByIndex(this.activeIndex - 1));
        if (nextButton) nextButton.addEventListener('click', () => this.setActiveByIndex(this.activeIndex + 1));

        dots.forEach((dot, i) => {
          dot.addEventListener('click', () => this.setActiveByIndex(i));
        });
      }
    }
  );
}